/**
 * Created by khanhduong on 11/9/17.
 */
import * as types from '../constants/actionTypes';
import * as commonActions from './commonActions';
import WebIM from '../libs/webIM';

export function updateRosterSuccess(roster) {
  return { type: types.CHAT_UPDATE_ROSTER_SUCCESS, roster };
}

export function updateMyRosterSuccess(options) {
  return { type: types.CHAT_UPDATE_MY_ROSTER_SUCCESS, options };
}

// get contact list
export function getContacts() {
  return dispatch => {
    WebIM.conn.getRoster({
      success: roster => {
        dispatch(updateRosterSuccess(roster));
      },
      error: error => {
        // TODO ERROR
      },
    });
  };
}

// remove contact
export function removeContact(id) {
  return dispatch => {
    // loading
    dispatch(commonActions.fetching());
    WebIM.conn.removeRoster({
      to: id,
      success() {
        // loading end
        dispatch(commonActions.fetched());
        dispatch(getContacts());

        WebIM.conn.unsubscribed({
          to: id,
        });
      },
      error() {},
    });
  };
}

// add contact
export function addContact(id) {
  return () => {
    WebIM.conn.subscribe({
      to: id,
      message: 'request', // i18n.t('request')
    });
  };
}

export function updateMyRoster(options) {
  return dispatch => {
    dispatch(updateMyRosterSuccess(options));
  };
}
